import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { removeCookieForBothDomains, setCookieForBothDomains } from './cookieHelpers'

//Hook that checks cookies. This is needed because we use different Authorization pacakges (Keycloak) for Next apps and React apps.
//There is an issue with them using different cookies, and therefore this check is added and used as a clean-up function / checker.

//The way it works, is we set a cookie in the react app when we are logged in there, and check that cookie in homeport apps and logs the user in silently if that is the case.
//This also works the other way if you log out by removing cookies, and adding cookies that tells each client that the user logged out.

type Props = {
  status: 'authenticated' | 'unauthenticated' | 'loading'
  signIn: (provider: string, options?: Record<string, unknown>, locale?: Record<string, unknown>) => void
  signOut: () => Promise<void>
  isDevelopment?: boolean
}

export function signOutWithCookies(isDevelopment: boolean, signOut: () => Promise<void>) {
  removeCookieForBothDomains(isDevelopment ? 'FL_LOGIN_BOOKING_TEST' : 'FL_LOGIN_BOOKING', {
    expires: 999,
    sameSite: 'Lax',
  })
  setCookieForBothDomains(isDevelopment ? 'FL_LOGOUT_FRONTPAGE_TEST' : 'FL_LOGOUT_FRONTPAGE', 'true', {
    expires: 999,
    sameSite: 'Lax',
  })
  signOut()
}

export function CheckCookies({ status, signIn, signOut, isDevelopment }: Props) {
  if (isDevelopment === undefined) return
  const bookingCookie = isDevelopment
    ? Cookies.get('FL_LOGIN_BOOKING_TEST') === 'true'
    : Cookies.get('FL_LOGIN_BOOKING') === 'true'

  useEffect(() => {
    if (status === 'loading') return
    if (status === 'authenticated') {
      removeCookieForBothDomains(isDevelopment ? 'FL_LOGOUT_FRONTPAGE_TEST' : 'FL_LOGOUT_FRONTAGE', {
        expires: 999,
        sameSite: 'Lax',
      })
    }
    if (Cookies.get(isDevelopment ? 'FL_LOGOUT_TEST' : 'FL_LOGOUT') === 'true') {
      signOut().then(() => {
        removeCookieForBothDomains(isDevelopment ? 'FL_LOGOUT_TEST' : 'FL_LOGOUT', { expires: 999, sameSite: 'Lax' })
      })
    }
  }, [bookingCookie, isDevelopment, signIn, signOut, status])
}
